module.exports = __webpack_public_path__ + "static/img/hou2.a4e3bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/hou2.png
// module id = xook
// module chunks = 0